import { FC } from "react";
import { Box, Stack, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import { InnovatricsDocTypeSingleSelect } from "./InnovatricsDocTypesMultiSelect";
import { CountryMultiSelect } from "../Countries/CountryMultiSelect";

export type FineTuneLineData = {
  id: string;
  documentType: string | null;
  allowedCountries: string[];
};

type FineTuneLineProps = {
  data: FineTuneLineData;
  onChange: (data: FineTuneLineData) => void;
  onRemove: (id: string) => void;
};

export const FineTuneLine: FC<FineTuneLineProps> = ({
  data,
  onChange,
  onRemove,
}) => {
  const handleDocumentTypeChange = (documentType: string | null) => {
    onChange({
      ...data,
      documentType,
    });
  };

  const handleCountriesChange = (allowedCountries: string[]) => {
    onChange({
      ...data,
      allowedCountries,
    });
  };

  const handleRemove = () => {
    onRemove(data.id);
  };

  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
        mt: 1,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Box sx={{ flexBasis: "200px", minWidth: "200px" }}>
          <InnovatricsDocTypeSingleSelect
            value={data.documentType}
            onChange={handleDocumentTypeChange}
            required
            size="small"
          />
        </Box>

        <Typography
          variant="body2"
          sx={{
            minWidth: "80px",
            fontWeight: 600,
            color: "#1C1F21",
          }}
        >
          only allow in
        </Typography>

        <Box sx={{ flex: 1, minWidth: "300px" }}>
          <CountryMultiSelect
            value={data.allowedCountries}
            onChange={handleCountriesChange}
            allowCountryGroups
            size="small"
          />
        </Box>

        <IconButton
          onClick={handleRemove}
          size="small"
          sx={{
            color: "#d32f2f",
            "&:hover": {
              backgroundColor: "#ffebee",
            },
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default FineTuneLine;
